<div class="px-2 py-12" fxFlex fxLayout="row" fxLayoutAlign="start space-between" class="header-bar">
    <div fxFlex fxLayout="row" fxLayoutAlign="start center" class="page-title">
        <span *ngIf="headerParams.resource.icon">
            <fa-icon size="lg" [icon]="headerParams.resource.icon" class="mr-16"></fa-icon>
        </span>
        <span class="h1">
            {{ headingKey }}
        </span>
    </div>

    <div fxFlex fxLayout="row" fxLayoutAlign="end center" style="margin-right: 20px">
        <ng-container [ngTemplateOutlet]="extraInfoTemplate"></ng-container>

        <div style="margin-right: 20px">
            <span *ngIf="groupActionProcessing$ | async">
                <nz-spin></nz-spin>
            </span>
        </div>
        <div *ngIf="headerParams.groupActions?.length > 0 && (!isCustomerUser || headerParams.showGroupActionsToCustomer)">
            <button id="di-list-header-action-dropdown" nz-button nz-dropdown nzTrigger="click" aria-label="Actions" [nzDropdownMenu]="menu">
                <span>Actions</span><i nz-icon nzType="down"></i>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                    <div *ngFor="let act of headerParams.groupActions">
                        <ng-container *ngIf="!act.subActions">
                            <li
                                *ngIf="headerParams.resource.name + '.pages.list.groupActions.' + act.label | roleShow | async"
                                nz-menu-item
                                id="{{ 'di-list-header-action-dropdown-menu-' + act.label }}"
                                [nzDisabled]="!(act.enabled$ | async)"
                                [ngClass]="!(act.enabled$ | async) ? 'disabled' : ''"
                                (click)="executeAction(act)">
                                <a [ngClass]="!(act.enabled$ | async) ? 'pointer-events-none' : ''">
                                    {{ headerParams.resource.name + '.pages.list.groupActions.' + act.label | translate }}
                                    <span *ngIf="act.dynamicValue"> ({{ act.dynamicValue }}) </span>
                                </a>
                            </li>
                        </ng-container>
                        <li
                            *ngIf="act.subActions"
                            nz-submenu
                            id="{{ 'di-list-header-action-dropdown-menu-' + act.label }}"
                            [nzTitle]="headerParams.resource.name + '.pages.list.groupActions.' + act.label | translate">
                            <ul>
                                <ng-container *ngFor="let subAction of act.subActions">
                                    <li
                                        *ngIf="headerParams.resource.name + '.pages.list.groupActions.' + subAction.label | roleShow | async"
                                        id="{{ 'di-list-header-action-dropdown-sub-menu-' + subAction.label }}"
                                        nz-menu-item
                                        [nzDisabled]="!(subAction.enabled$ | async)"
                                        [ngClass]="!(subAction.enabled$ | async) ? 'disabled' : ''"
                                        (click)="executeAction(subAction)">
                                        <a [ngClass]="!(subAction.enabled$ | async) ? 'pointer-events-none' : ''">
                                            {{ headerParams.resource.name + '.pages.list.groupActions.' + subAction.label | translate }}
                                            <span *ngIf="subAction.dynamicValue"> ({{ subAction.dynamicValue }}) </span>
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </li>
                    </div>
                </ul>
            </nz-dropdown-menu>
        </div>

        <ng-container [ngTemplateOutlet]="extraButtonTemplate"></ng-container>

        <button
            *ngIf="headerParams.showAddButton && (this.headerParams.resource.name + '.pages.list.buttons.add' | roleShow | async)"
            nz-button
            id="di-list-page-header-add-button"
            nzType="primary"
            class="mx-8 mb-6"
            (click)="headerParams.addAction()">
            <i nz-icon nzType="plus" class="mr-2"></i><span>{{ addButtonTextKey | translate }}</span>
        </button>

        <button
            *ngIf="headerParams.showRefresh"
            nz-button
            id="di-list-page-header-refresh-button"
            nzType="primary"
            class="mx-8 mb-6"
            aria-label="Refresh"
            (click)="headerParams.refreshAction()">
            <i nz-icon nzType="reload" class="mr-2"></i><span>{{ 'Refresh' }}</span>
        </button>
    </div>

    <di-search-bar id="di-list-page-header-search-bar" [show]="showSearchBar"></di-search-bar>
    <div fxLayoutAlign="end center" *ngIf="headerParams.helpLink">
        <di-help [link]="headerParams.helpLink"></di-help>
    </div>
</div>
